import { render, staticRenderFns } from "./FollowUpActivitiesCRO.vue?vue&type=template&id=2f4935cc&scoped=true"
import script from "./FollowUpActivitiesCRO.vue?vue&type=script&lang=js"
export * from "./FollowUpActivitiesCRO.vue?vue&type=script&lang=js"
import style0 from "./FollowUpActivitiesCRO.vue?vue&type=style&index=0&id=2f4935cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4935cc",
  null
  
)

export default component.exports